import type { DeliveryResolver } from '@grandvisionhq/shipping'
import { defaultDeliveryResolver } from '@grandvisionhq/shipping'
import { isPresent } from '@grandvisionhq/utils'

type DeliveryResolverFactory = (products?: any[], productType?: string) => DeliveryResolver

export const deliveryResolverFactory: DeliveryResolverFactory = (products, productType) => {
  return (config, availability) => {
    if (Array.isArray(products)) {
      // Custom logic which bene uses at this moment:
      // - when mixed cart, show default delivery days: 5+
      // - when cart has only sunglasses, show next day delivery: 1
      const types = new Set(products.map((p) => p.type).filter(isPresent))

      if (types.size > 1) {
        return ['5+']
      } else if (productType === 'sunglasses' || types.has('sunglasses')) {
        return ['1']
      }
    }

    return defaultDeliveryResolver(config, availability)
  }
}
